import { Typography } from "antd";
import React from "react";

export default function UserInfo() {
  return (
    <>
      <Typography.Title className="header-title">One drop at a time</Typography.Title>
    </>
  );
}
